import { ArrowUpRight } from '../common/Brand'

interface SignupActionsProps {
  isFirstStep: boolean
  saving: boolean
  onBack: () => void
  onContinue: () => void
}

export function SignupActions({
  isFirstStep,
  saving,
  onBack,
  onContinue
}: SignupActionsProps) {
  return (
    <div className="flow-actions">
      <button
        className="back"
        type="button"
        onClick={onBack}
        disabled={isFirstStep}
      >
        ← Back
      </button>
      <button
        className="next"
        type="button"
        onClick={onContinue}
        disabled={saving}
      >
        {saving ? (
          'Saving…'
        ) : (
          <>
            {isFirstStep ? 'Submit' : 'Finish signup'} <ArrowUpRight />
          </>
        )}
      </button>
    </div>
  )
}
